import type { ServiceStatus } from '@/lib/schemas/db'

/** Terminal statuses: the record is closed and its fields stop being editable. */
const LOCKED_STATUSES = ['Invoiced', 'Cancelled'] as const

export type LockedServiceStatus = (typeof LOCKED_STATUSES)[number]

/**
 * Whether a service is locked, i.e. closed.
 *
 * The single source of truth for a predicate that used to be re-spelled as
 * `status === 'Invoiced' || status === 'Cancelled'` in every screen and hook
 * that cared, which is how the callout and session screens ended up disagreeing
 * about it.
 */
export function isServiceLocked(
  status: string | undefined,
): status is LockedServiceStatus {
  return LOCKED_STATUSES.includes(status as LockedServiceStatus)
}

/** Narrow a status to the locked pair, for components that only accept those. */
export function asLockedStatus(
  status: ServiceStatus | string,
): LockedServiceStatus {
  return status === 'Cancelled' ? 'Cancelled' : 'Invoiced'
}
